import * as yup from 'yup';
import { sharedAnytimeFields } from '../shared/sharedAnytimeSchema';

export const bikeAnytimeSchemaBuilder = (
  firstDriverAdditionalPremiumAge,
  secondDriverAdditionalPremiumAge,
  firstDriverAdditionalPremiumLicenseYears,
  secondDriverAdditionalPremiumLicenseYears,
  legalEntity,
  secondDriver,
  discountEntity,
  vehicleType
) => {
  return yup.object({
    ...sharedAnytimeFields(
      firstDriverAdditionalPremiumAge,
      secondDriverAdditionalPremiumAge,
      firstDriverAdditionalPremiumLicenseYears,
      secondDriverAdditionalPremiumLicenseYears,
      legalEntity,
      secondDriver,
      discountEntity,
      vehicleType
    ),
  });
};

export default bikeAnytimeSchemaBuilder;
